import { Guest } from "../../guests/models/Guest";
import { Property } from "../../properties/models/Property";
import { Reservation } from "../../reservations/models/Reservation";
import { Currency } from "../../currencies/models/Currency";
import { Organization } from "../../organizations/models/Organization";

export const ACTIVE_CLAIM_TAB = 'ACTIVE CLAIMS';

export enum CLAIM_STATUS {
  DRAFT = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  DENIED = 4
}

export interface Claim {
  id: string;
  reservation_id: string;
  organization_id: number;
  organization?: Organization;
  organization_name?: string;
  property_id: number;
  reservation_change: any;
  estimate_amount: string;
  actual_amount: any;
  send_check_to: number;
  send_check_to_name: string;
  send_check_to_phone: string;
  send_check_to_email: string;
  send_check_to_address_id: number;
  send_check_to_address: any;
  damage_date: string;
  claim_cause_damage_rental_property: any;
  claim_cause_damage_guest_property: any;
  claim_cause_injury: any;
  claim_cause_theft_fire: any;
  claim_cause_other: any;
  injury_name: string;
  injury_phone: string;
  injury_description: string;
  damage_description: string;
  home_liveable: any;
  additional_comment: string;
  admin_comment: string;
  is_admin_comment_visible: number;
  status_id: number;
  created_date: string;
  updated_date: string;
  account_id: number;
  is_active: any;
  guest_rate: number;
  would_rent_again: any;
  damage_accidental: number;
  claim_guest_party: number;
  claim_guest_pets: number;
  claim_guest_disturbed_neighbours: number;
  claim_guest_too_many_people: number;
  claim_guest_stole: number;
  claim_other_issue: any;
  claim_guest_other: number;
  reservation: Reservation;
  property: Property;
  first_guest: Guest;
  status_history: ClaimStatus[];
  claim_documents: ClaimDocument[];
  currency_id: number;
  currency: Currency;
  injury_address_id?: number;
  injury_address?: {
    id?: number,
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country_id?: string;
    country_name?: string;
  };
  goverment_department_id?: number;
  goverment_department?: {
    id?: number;
    name?: string;
    case_number?: string;
    officer_name?: string;
    officer_phone?: string;
  }
}

export interface ClaimDocument {
  id?: number;
  claim_id?: number;
  description: string;
  file_name: string;
  file_id?: number;
  error?: boolean;
}

export interface ClaimStatus {
  id: number;
  claim_id: number;
  status_id: number;
  status_date: string;
}

export interface ClaimRow {
  id: string;
  organizationId: number;
  organizationName: string;
  referenceId: string;
  reservationId: number;
  propertyName: string;
  firstName: string;
  lastName: string;
  reservationDates: string;
  arrivalDate?: string;
  estimateAmount: string;
  actualAmount: string;
  pillStatus: string;
  action?: boolean;
}